import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { COLOR_SCHEME_LOCAL_STORAGE_KEY, ColorScheme } from './color-scheme.models';

@Injectable({
    providedIn: 'root'
})
export class ColorSchemeService {
    private _renderer: Renderer2;

    // Define prefix for clearer and more readable class names in scss files
    private _colorSchemePrefix = 'color-scheme-';

    constructor(
        private _rendererFactory: RendererFactory2
    ) {
        // Create new renderer from renderFactory, to make it possible to use renderer2 in a service
        this._renderer = _rendererFactory.createRenderer(null, null);
    }

    public update(scheme: ColorScheme) {
        this._saveColorSchemeToLocalStorage(scheme);

        // Remove the old color-scheme class
        this._removeClassStartsWith( document.body, this._colorSchemePrefix);

        // Add the new / current color-scheme class
        this._renderer.addClass(document.body, this._colorSchemePrefix + scheme);
    }

    private _saveColorSchemeToLocalStorage(scheme: ColorScheme) {
        // Save prefers-color-scheme to localStorage
        localStorage.setItem(COLOR_SCHEME_LOCAL_STORAGE_KEY, scheme);
    }

    private _removeClassStartsWith(node, className) {
        [...node.classList].forEach(v => {
            if (v.startsWith(className)) {
                node.classList.remove(v);
            }
        });
    }
}
